/**
 * Assigns data-component-count attributes:
 * - "component-N" for top-level components (direct children of .container)
 * - "component-N-M" for nested components inside top-level ones
 */

export const dataComponentCount = () => {
    const parentComponents = document?.querySelector('#main .container')?.children

    Array.from(parentComponents).forEach((parentComponent, index) => {
        const prefix = `component-${index}`
        parentComponent.setAttribute('data-component-count', prefix)
        recursiveExecution(parentComponent, prefix)
    })
}

const recursiveExecution = (parentComponent, prefix) => {
    const childComponents = Array.from(parentComponent.querySelectorAll('.container .component'))
    const einsteinComponents = Array.from(
        parentComponent.querySelectorAll(
            '.container .apparel-product-tile-carousel .product-tile-image-block'
        )
    )
    const thinkAnalyticsComponents = Array.from(
        parentComponent.querySelectorAll('.container .slick-list .product-tile-image-block')
    )

    if (childComponents?.length > 0) {
        childComponents.forEach((childComponent, index) => {
            const childPrefix = `${prefix}-${index}`
            childComponent.setAttribute('data-component-count', childPrefix)
            recursiveExecution(childComponent)
        })
    } else if (einsteinComponents?.length > 0) {
        einsteinComponents.forEach((einsteinComponent, index) => {
            const einsteinPrefix = `${prefix}-${index}`
            einsteinComponent.setAttribute('data-component-count', einsteinPrefix)
        })
    } else if (thinkAnalyticsComponents?.length > 0) {
        thinkAnalyticsComponents.forEach((thinkAnalyticsComponent, index) => {
            const thinkAnalyticsPrefix = `${prefix}-${index}`
            thinkAnalyticsComponent.setAttribute('data-component-count', thinkAnalyticsPrefix)
        })
    }
}

export const carouselDataComponentCount = (homePage) => {
    // Get all product carousels first
    const carousels = document.querySelectorAll('.carousel-wrapper')

    // Process each carousel
    carousels.forEach((carousel, carouselIndex) => {
        if (homePage) {
            const parentComponent = carousel.closest('.component[data-component-count]')
            const prefix = parentComponent?.getAttribute('data-component-count')
            if (prefix) {
                const position = prefix?.split('-') || []
                carouselIndex = position?.[1] ? Number(position[1]) : carouselIndex
            }
        }
        const carouselPrefix = `component-${carouselIndex}`
        carousel.setAttribute('data-component-count', carouselPrefix)

        // Process slick-slide children within each carousel
        const slickSlides = carousel.querySelectorAll('[data-index]')
        slickSlides.forEach((slide, slideIndex) => {
            const slidePrefix = `${carouselPrefix}-${slideIndex}`
            slide.setAttribute('data-component-count', slidePrefix)
        })
    })
}
